import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"

import api from "assets/services/api";


function ModalUpdateDeliverymans(props) {
    const { storageId } = useAuth();

    const [deliverymanname, setDeliverymanName] = useState(props.props.deliverymanname);
    const [deliveryuser, setDeliveryuser] = useState(props.props.deliveryusername);
    const [password, setPassword] = useState('');

    const [br, setBR] = useState(false);
    const [controlSnack, setControlSnack] = useState(false);
    useEffect(() => {
        if (controlSnack) { showNotification("br") }
    }, [controlSnack]);
    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                        props.onHide();
                    }, 700);
                }
                break;
            default:
                break;
        }
    };
    async function handleEditDeliveryman(e) {
        e.preventDefault();
        const response = await api.put(`/deliveryman/${props.props.id}`, {
            deliverymanname: deliverymanname,
            deliveryusername: deliveryuser,
            password: password,
            id_admin: storageId
        });
        if (response.status === 200) {
            setControlSnack(true);
            props.getAllDeliverymans();
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar entregador
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleEditDeliveryman}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formNameDeliveryman">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control onChange={event => setDeliverymanName(event.target.value)} type="text" value={deliverymanname} placeholder="Nome do entregador" autoComplete='off' />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formUsernameDeliveryman">
                            <Form.Label>Usuário</Form.Label>
                            <Form.Control onChange={event => setDeliveryuser(event.target.value)} value={deliveryuser} type="text" placeholder="Usuário do login" autoComplete='off' />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formPasswordDeliveryman">
                            <Form.Label>Senha</Form.Label>
                            <Form.Control onChange={event => setPassword(event.target.value)} value={password} type="password" placeholder="Senha do entregador" autoComplete='off' />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Salvar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Entregador editado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateDeliverymans;